import { useEffect, useState } from 'react';

import { DepositStep, TransactionStatus } from '../constants';

import useGetTransactionInfo from './use-get-transaction-info';
import useSendTransaction from './use-send-transaction';
import useParseUrl from './use-parse-url';
import useRedirect from './use-redirect';
import { UseDeposit } from './types';
import useParseResultRedirect from './use-parse-result-redirect';

const useDeposit: UseDeposit = () => {
  const { transactionId, stepStart, success } = useParseUrl();
  const [step, setStep] = useState<DepositStep>(stepStart);
  const [error, setError] = useState<string | undefined>(undefined);
  const { transaction, onGetTransaction } = useGetTransactionInfo({ transactionId, setError });
  const { onSendTransaction } = useSendTransaction({ setError });
  const { onGetRedirect } = useRedirect({ transactionId, setError, success });
  const { onParseResultRedirect } = useParseResultRedirect({ transactionId, setError });

  useEffect(() => {
    switch (step) {
      case DepositStep.StartPrepare: {
        const getTransactionInfo = async () => {
          const result = await onGetTransaction();

          switch (result) {
            case TransactionStatus.Success:
              setStep(DepositStep.SendTransaction);
              break;
            case TransactionStatus.Unavailable:
              setStep(DepositStep.TransactionUnavailable);
              break;
            case TransactionStatus.Error:
              setStep(DepositStep.Error);
              break;
            default:
              setStep(DepositStep.Error);
              break;
          }
        };

        getTransactionInfo();
        break;
      }
      case DepositStep.SendTransaction: {
        const sendTransaction = async () => {
          const result = await onSendTransaction(transaction);

          setStep(result ? DepositStep.Success : DepositStep.Error);
        };

        sendTransaction();
        break;
      }
      case DepositStep.StartRedirect:
      {
        const callRedirect = async () => {
          const result = await onGetRedirect();

          setStep(result ? DepositStep.Success : DepositStep.Error);
        };

        callRedirect();
        break;
      }
      case DepositStep.StartParseResultRedirect:
      {
        const callRedirect = async () => {
          const result = await onParseResultRedirect();

          setStep(result ? DepositStep.Success : DepositStep.Error);
        };

        callRedirect();
        break;
      }
      case DepositStep.Error:
        if (!error) {
          setError('error');
        }
        console.error(error);
        break;
      default:
        break;
    }
  }, [step]);

  return { step, transaction };
};

export default useDeposit;
